import React, {useEffect, useState} from 'react';
import './scss/contract-add.scss';
import FullScreenLoader from './full-screen';
import ProcessContractModel from '../models/process-contract';
import Utils from '../common/utils';
import ProcessUpdateContractProp from './properties/process-update-contract';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function ProcessUpdateContract({hash, setStatusMessage, handleClose}: ProcessUpdateContractProp):
    React.ReactElement {
    const processContractInit: ProcessContractModel = {
        endBlock: '',
        status: '',
        blockRange: '',
        startBlock: '',
        hash: '',
        lastUpdateTime: '',
        lastBlockProcessed: '',
        collections: [],
        standard: '',
        lastBlockSaved: '',
        metadataType: ''
    };
    const [processContract, setProcessContract] = useState(processContractInit);
    const [processId, setProcessId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');

    function validateForm() {

        if (!processContract) {
            setErrorMessage('Unable to get contract details.');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (!processContract.status || (processContract.status
            && processContract.status.length === 0)) {
            setErrorMessage('Please select status');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (processContract.startBlock && !Utils.validateNumber(processContract.startBlock)) {
            setErrorMessage('Please enter valid start block number');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (processContract.endBlock && !Utils.validateNumber(processContract.endBlock)) {
            setErrorMessage('Please enter valid end block number');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (processContract.startBlock && processContract.endBlock
            && Number(processContract.startBlock) > Number(processContract.endBlock)) {
            setErrorMessage('Start block number should be less than or equal to end block');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (processContract.blockRange && !Utils.validateNumber(processContract.blockRange)) {
            setErrorMessage('Please enter valid block range');
            setSetErrorClass('error mb-4');
            return false;
        }

        return true;
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();

        if (validateForm()) {
            setIsLoading(true);
            SandraJsAPI.updateProcessContract(processContract, processId)
                .then((res) => {
                    if (res.error) {
                        setStatusMessage(res.error.message, StatusMessageTypeEnum.error);
                    } else
                        setStatusMessage('Contract details updated, please refresh the page', StatusMessageTypeEnum.success);
                    setIsLoading(false);
                    window.scrollTo(0, 0);
                    handleClose();
                })
                .catch((reason) => {
                    setStatusMessage(reason.message, StatusMessageTypeEnum.error);
                    setIsLoading(false);
                    window.scrollTo(0, 0);
                    console.log(reason);
                    handleClose();
                });
        }
    };
    useEffect(() => {
        setIsLoading(true);
        setErrorMessage('');
        setSetErrorClass('');
        SandraJsAPI.getProcessContractAsync(hash).then((res) => {
            setIsLoading(false);
            if (res.error) {
                setStatusMessage(res.error.message, StatusMessageTypeEnum.error);
            } else if (res.data) {
                setProcessContract(res.data);
                setProcessId(res.data.id);
            }
        }).catch((reason) => {
            setStatusMessage(reason.message, StatusMessageTypeEnum.error);
            setIsLoading(false);
            window.scrollTo(0, 0);
            console.log(reason);
        });
    }, []);

    return (
        <div className="rounded add-process-box loading-wrapper">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <h5 className="p-1 mb-3">Update Process Contract Info</h5>
            <form onSubmit={handleSubmit}>
                <div className={errorClass}>{errorMessage}</div>
                <div className="mb-3 row">
                    <div className="col-12">
                        <div className="mb-2 ms-1 form-label fst-italic">Select Status</div>
                        <select
                            aria-label="Select"
                            onChange={(e) => {
                                setProcessContract({...processContract, status: e.target.value});
                            }}
                            className="form-select"
                            value={processContract.status}
                        >
                            <option value="">Select</option>
                            <option value="active">Active</option>
                            <option value="inactive">In Active</option>
                        </select>
                    </div>
                    <div className="col-6 d-none">
                        <div className="mb-2 ms-1 form-label fst-italic">Metadata Type</div>
                        <select
                            aria-label="Select"
                            onChange={(e) => {
                                setProcessContract({...processContract, metadataType: e.target.value});
                            }}
                            className="form-select"
                            value={processContract.metadataType}
                        >
                            <option value="">Select Metadata Type</option>
                            <option value="http">Http</option>
                            <option value="ipfs">IPFS</option>
                            <option value="inTokenUrl">Metadata in token url</option>
                        </select>
                    </div>
                </div>
                <div className="mb-0">
                    <div className="row">
                        <div className="col-6">
                            <label htmlFor="startBlock" className="form-label w-100">
                                Start Block (optional)
                                <input
                                    type="number"
                                    id="startBlock"
                                    className="form-control mt-1 d-block"
                                    value={processContract.startBlock}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setProcessContract({...processContract, startBlock: e.target.value});
                                    }}
                                />
                                <span className="text-sm-light fst-italic p-1 d-block">Start scan from this block number, default value is 0</span>
                            </label>
                        </div>
                        <div className="col-6">
                            <label htmlFor="endBlock" className="form-label w-100">
                                End Block (optional)
                                <input
                                    type="text"
                                    id="endBlock"
                                    className="form-control mt-1 d-block"
                                    value={processContract.endBlock}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setProcessContract({...processContract, endBlock: e.target.value});
                                    }}
                                />
                                <span className="text-sm-light fst-italic p-1 d-block">Scan to this block number, if not set then jetski process should continues scan for till latest block</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="mb-2 w-100">
                    <div className="row">
                        <div className="col-6">
                            <label htmlFor="blockRange" className="form-label w-100">
                                Block Range (optional)
                                <input
                                    type="text"
                                    id="blockRange"
                                    className="form-control"
                                    value={processContract.blockRange}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setProcessContract({...processContract, blockRange: e.target.value});
                                    }}
                                />
                                <span className="text-sm-light fst-italic p-1 d-block">Range of block number to be scanned per request, default value is 5000</span>
                            </label>
                        </div>
                        <div className="col-6 d-none">
                            <label htmlFor="endBlock" className="form-label w-100">
                                Last Block Saved (optional)
                                <input
                                    type="text"
                                    id="lastBlockSaved"
                                    className="form-control mt-1 d-block"
                                    value={processContract.lastBlockSaved}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setProcessContract({...processContract, lastBlockSaved: e.target.value});
                                    }}
                                />
                                <span
                                    className="text-sm-light fst-italic p-1 d-block">Last block saved during scanning</span>
                            </label>
                            <span className="text-sm-light fst-italic d-block">
                If jetski starts the scanning again it will always start scan from
                this block and not from start block. Only change last block saved when you
                want to scan this contract from a different block other than start block.
              </span>
                        </div>
                    </div>
                </div>
                <button type="submit" className="btn btn-dark">Update</button>
            </form>
        </div>
    );
}

export default ProcessUpdateContract;
